import classNames from "classnames";
import { trackCompanyLogo } from "~/app/analytics/ga/ga";
import { HOMEPAGE } from "~/utils/url/staticUrls";

type DivProps = JSX.IntrinsicElements["div"];

export interface Props extends DivProps {
  className?: string;
  /**
   * URI of an image
   * @example '/_ui/responsive/theme-alpha/images/schaeffler-logo.svg'
   */
  logoUrl?: string;
  /**
   * @example 'Schaeffler's logo'
   */
  alt?: string;
}

/**
 * Primary UI component for rendering the main logo and _home_ link.
 * Also handles the `trackCompanyLogo' click event.
 */
export const CompanyLogo = ({
  className,
  logoUrl = "/_ui/responsive/theme-alpha/images/schaeffler-logo.svg",
  alt = "Schaeffler's logo",
  ...rest
}: Props) => {
  return (
    <div className={classNames("scha__company-logo", className)} {...rest}>
      <a href={HOMEPAGE} onClick={trackCompanyLogo}>
        <img src={logoUrl} alt={alt} data-test-id={"schaeffler-logo"} />
      </a>
    </div>
  );
};
